import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';

interface PropTypes {
  editorState?: string;
}

export function UpdateStatePlugin(props: PropTypes) {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (props.editorState == null) {
      return;
    }

    editor.setEditorState(editor.parseEditorState(props.editorState));
  }, [editor, props.editorState]);

  return null;
}
